import {
  Button,
  Container,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  VStack,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { UserRole } from '../services/auth'

const Login = () => {
  const { login, register, error } = useAuth()
  const navigate = useNavigate()
  const toast = useToast()
  const [isRegistering, setIsRegistering] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const role: UserRole = 'participant'
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      if (isRegistering) {
        await register({ email, password, role })
        toast({
          title: 'Registration successful',
          status: 'success'
        })
      } else {
        await login({ email, password })
        toast({
          title: 'Login successful',
          status: 'success'
        })
      }
      navigate('/')
    } catch (err) {
      toast({
        title: 'Error',
        description: error || 'An error occurred',
        status: 'error'
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Container maxW="container.sm" py={10}>
      <VStack spacing={6} as="form" onSubmit={handleSubmit}>
        <Heading>{isRegistering ? 'Register' : 'Login'}</Heading>

        <FormControl isRequired>
          <FormLabel htmlFor="email">Email</FormLabel>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel htmlFor="password">Password</FormLabel>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormControl>

        <Button
          type="submit"
          colorScheme="blue"
          width="full"
          isLoading={isLoading}
        >
          {isRegistering ? 'Register' : 'Sign In'}
        </Button>

        <Text cursor="pointer" color="blue.500" onClick={() => setIsRegistering(!isRegistering)}>
          {isRegistering
            ? 'Already have an account? Login'
            : 'Need an account? Register'}
        </Text>
      </VStack>
    </Container>
  )
}

export default Login
